import { env } from './env';
import { Currency } from './types/currency';

export const getCurrency = (currencyCode: string, currencies: Currency[]) => {
  const currency = currencies.find((c) => c.code === currencyCode);

  if (!currency) {
    // This really shouldn't happen
    throw new Error(`Could not find currency ${currencyCode}`);
  }

  let transactionalCurrency = currencies.find((c) => c.code === currencyCode && c.isTransactional);

  if (!transactionalCurrency) {
    transactionalCurrency = currencies.find(
      (c) => c.code === env.NEXT_PUBLIC_DEFAULT_CURRENCY_CODE && c.isTransactional,
    );
  }

  if (!transactionalCurrency) {
    throw new Error('transactional currency not found');
  }

  return {
    currency,
    transactionalCurrency,
  };
};
